import slice from './slice'

export const { reducer, actions } = slice
